import {ExclamationCircleIcon} from '@heroicons/react/24/solid';

import {useTranslations} from 'src/components/TranslationsContext';

export default function VizErrorMessage() {
  const {t} = useTranslations();
  return (
    <div>
      <div className=" flex justify-center items-center">
        <ExclamationCircleIcon className="h-6 w-6 text-red-600 mt-1 mr-1" aria-hidden="true" />{' '}
        <span className="text-gray-700">{t('errorVisualizingData')}</span>
      </div>
      <div className="text-sm text-gray-700 max-w-xs mt-2 text-center">
        {t('errorVisualizingDataDetail')}
      </div>
    </div>
  );
}
